module.exports = __webpack_public_path__ + "img/logo-preto-estacio.60f5191f.svg";